import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faPhone,
  faAt,
} from "@fortawesome/free-solid-svg-icons";
import M from "./M.svg";
import logo from "./logo2.svg";
import MarcaTexto from "./MarcaTexto.svg";
import Miltec from "./MilTec.svg";
import "./rodape.css";
import { Link } from "react-router-dom";

function Rodape() {
  return (
    <footer className="rodapeBk">
      <div className="rodapeContainer">
        <div className="containerListaDeInformacoes">
          <h5 className="tituloListaDeInformacoes">Contatos.</h5>
          <ul className="listaInformacoes">
            <li className="listaInformacoesEndereco">
              <FontAwesomeIcon icon={faLocationDot} color="#d49a08" />
              <a
                href="https://www.google.com/maps?q=Rua+Dr.+Antônio+Alves+Arantes,+474,+Chácara+Cachoeira,+Campo+Grande,+MS,+79040-720"
                target="_blank"
                rel="noopener noreferrer"
              >
                Rua Dr. Antônio Alves Arantes, 474 - Chácara Cachoeira
                <br />
                CEP: 79040-720 - Campo Grande, MS
              </a>
            </li>
            <li>
              <FontAwesomeIcon icon={faPhone} color="#d49a08" />
              <a href="tel:+556733026802">Fone: 67 3302-6802</a>
            </li>
            <li>
              <FontAwesomeIcon icon={faAt} color="#d49a08" />
              <a href="mailto:contato@miltecti.com.br">
                E-mail: contato@miltecti.com.br
              </a>
            </li>
          </ul>
        </div>
        <div className="informacoesLogo">
          <div>
            <Link to={"/milshop"}>
              <img src={MarcaTexto} alt="Logo MilShop" />
            </Link>
            <Link to={"https://www.miltecti.com.br/"}>
              {" "}
              <img src={Miltec} alt="Logo Miltec" />{" "}
            </Link>
          </div>
          <p className="footer-copy font-2-m cor-6">
            MilShop © todos os direitos reservados.
          </p>
        </div>
        {/* <div className='iframe'>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3738.0555507253616!2d-54.587355725076684!3d-20.462911455123724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9486e88d099fd157%3A0x26c7eadb109c9f4f!2sMil%20Tec%20Tecnologia!5e0!3m2!1spt-BR!2sbr!4v1714827344505!5m2!1spt-BR!2sbr" width={'600px'} style={{ border: "0" }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                </div> */}
      </div>
    </footer>
  );
}

export default Rodape;
